import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { ServiceHistoryFleetView, ServiceHistoryVehicleExpandedView, ServiceHistoryVehicleTileView, } from './components';
const APP_VERSION = '0.1.1';
function resolveViewRoute(pathname) {
    const lastPathSegment = pathname
        .toLowerCase()
        .split('/')
        .filter(Boolean)
        .pop();
    if (lastPathSegment === 'service-history-fleet-view') {
        return 'fleet';
    }
    if (lastPathSegment === 'service-history-vehicle-expanded-view') {
        return 'expanded';
    }
    if (lastPathSegment === 'service-history-vehicle-tile-view') {
        return 'tile';
    }
    return 'all';
}
function App({ appName, basePath }) {
    const pathname = typeof window === 'undefined' ? '/' : window.location.pathname;
    const currentViewRoute = resolveViewRoute(pathname);
    const resolvedAppName = appName ?? process.env.APP_NAME ?? 'Unified Service Management UI';
    const environment = process.env.APP_ENVIRONMENT ?? 'development';
    return (_jsxs("main", { className: "app-shell", children: [_jsxs("div", { className: "hero-meta", "aria-label": "application metadata", children: [_jsxs("span", { children: ["App: ", _jsx("strong", { children: resolvedAppName })] }), _jsxs("span", { children: ["Environment: ", _jsx("strong", { children: environment })] }), _jsxs("span", { children: ["Base path: ", _jsx("strong", { children: basePath ?? '/' })] }), _jsxs("span", { children: ["Version: ", _jsxs("strong", { children: ["v", APP_VERSION] })] })] }), _jsxs("section", { className: "app-components", children: [(currentViewRoute === 'all' || currentViewRoute === 'fleet') && (_jsx("div", { className: "component-section", children: _jsx(ServiceHistoryFleetView, {}) })), (currentViewRoute === 'all' || currentViewRoute === 'expanded') && (_jsx("div", { className: "component-section", children: _jsx(ServiceHistoryVehicleExpandedView, {}) })), (currentViewRoute === 'all' || currentViewRoute === 'tile') && (_jsx("div", { className: "component-section", children: _jsx(ServiceHistoryVehicleTileView, {}) }))] })] }));
}
export default App;
